import React, {createRef, useEffect, useState} from 'react';
import {useQueryClient} from "react-query";
import moment from "moment";
import __ from "lodash";
import {Grid, InputLabel} from "@material-ui/core";
import axios from "axios";

import {FormDialog, MaskedNumber, MaskedText, Text }from "../../../controls";
import useCostingExists from '../../../services/trips/useCostingExists';
import AttachCostingValidator from "../validators/AttachCostingValidator.js";

const CostingDetails = (props) => {

  console.log("record", props.record);
  const queryClient = props.queryClient;

  const costing = useCostingExists({queryClient, useCache: false, extraKeys: [props?.record?.costingNumber]});

  if (props.record?.costingUuid !== costing.data?.costingUuid) {
    props.changeRecord({
      ...props.record,
      costingUuid: costing.data?.costingUuid
    });
  }

  return (
    <Grid container>
      <Grid item xs={2}>
        <Text label="Costing Number" value={costing.data?`UCN-${costing.data?.costingNumber}`:""} defaultValue={costing.data?.costingNumber} fullWidth={true}/>
      </Grid>
      <Grid item xs={2}>
        <Text label="Costing Date" value={costing.data?.costingDate ? moment(costing.data?.costingDate).format("DD MMM YYYY") : ""} fullWidth={true}/>
      </Grid>
      <Grid item xs={2}>
        <Text label="Aircraft Reg" value={costing.data?.aircraftReg} fullWidth={true}/>
      </Grid>
      <Grid item xs={2}>
        <div style={{padding: "0px 10px"}}>
          <MaskedNumber 
            label = "Total Costs" 
            value={costing.data?.requiredRevenue} 
            fullWidth={true}       
            prefix="$" 
            displayType="text" 
            readOnly={true}
            inputLabelProps={{ shrink: true }}
            style={{position: "absolute",marginTop: 6}}          
        />
        </div>
      </Grid>
      <Grid item xs={2}>
      <div style={{padding: "0px 10px"}}>
          <MaskedNumber 
            label = "Total Revenue" 
            value={costing.data?.totalRevenue} 
            fullWidth={true}       
            prefix="$" 
            displayType="text" 
            readOnly={true}
            inputLabelProps={{ shrink: true }}
            style={{position: "absolute",marginTop: 6}}          
        />
        </div>
      </Grid>
      <Grid item xs={2}>
      <div style={{padding: "0px 10px"}}>
          <MaskedNumber 
            label = "Profit" 
            value={costing.data?.profit} 
            fullWidth={true}       
            prefix="$" 
            displayType="text" 
            readOnly={true}
            inputLabelProps={{ shrink: true }}
            style={{position: "absolute",marginTop: 6}}          
        />
        </div>
      </Grid>
      {/* <Grid item xs={5}>
        <Text label = "Commercial Owner" value={costing.data?.commercialOwnerId} fullWidth={true}/>
      </Grid>      */}
      <Grid item xs={6}>
        <Text label = "Trip Routing" value={costing.data?.tripRouting} fullWidth={true}/>
      </Grid>
      <Grid item xs={3}>
        <Text label = "Truck Routing" value={costing.data?.truckRouting} fullWidth={true}/>
      </Grid>
      <Grid item xs={3}>
        <Text label = "Onward Routing" value={costing.data?.onwardRouting} fullWidth={true}/>
      </Grid>
    </Grid>
  )
}

const AttachCostingDialog = (_props) => {
  const props = {
    canEdit: false,
    ..._props,
  }
  const apiSitePrefix = props.apiSitePrefix
  const SystemData = props.SystemData;
  const classes = props.classes;

  const eventBus = SystemData.eventBus;

  const [dialogStates, setDialogStates] = useState({
    showDialog: false,
    record: {},
    title: 'Attach Costing',
  });

  const queryClient = useQueryClient();

  useEffect(()=> {
    const open = async (record) => {
      setDialogStates({...dialogStates, showDialog:true, record});
    }
    eventBus.bind("AttachCostingDialog.open", open);

    return () => {
      eventBus.unbind("AttachCostingDialog.open", open);
    }
  }, [dialogStates, eventBus]);


  if (dialogStates.showDialog) {
    return (
      <FormDialog
        title={dialogStates.title}
        message="Please enter the costing number you wish to attach to the Enquiry"
        open={dialogStates.showDialog}
        record={__.cloneDeep(dialogStates.record)}
        dialogOptions={{width: "lg", maxWidth: "md", fullWidth: true}}
        classes={classes}
        validator={AttachCostingValidator}
        buttons = {{
          save:{icon: "check_circle", key: "Attach", label: "Attach", color: "primary", disabled: (status)=>{
            if (status.buttonState && status.buttonState.disabled) return true;
            return status.error;
          }},
          cancel:{icon: "check_circle", key: "Cancel", label: "Close", color: "primary"}
        }}
        onChange={(state) => {
          if (state.buttonPressed === "save") {
            const record = state.record;
            axios.put(`${apiSitePrefix}/enquiries/attachcosting/${record.enquiryUuid}/${record.costingUuid}`)
            .then(response => {
              SystemData.toggleLoadingProgress(false);
              queryClient.invalidateQueries(['EnquiryActivities', record.enquiryUuid]);
              setDialogStates({...dialogStates, showDialog: false, record: null});
              if (props.afterSave) {
                props.afterSave();
              }
            })
            .catch(function (error) {
              if (!error?.response?.data) {
                SystemData.alert("Error", `Attach costing failed. Server is not responding`);
                SystemData.toggleLoadingProgress(false);
              } else if (error?.response?.data?.errorMessage) {
                SystemData.alert("Error", `Attach costing failed. ${error.response.data.errorMessage}`);
                SystemData.toggleLoadingProgress(false);
              } else {
                SystemData.alert("Error", `Attach costing failed. An unexpected error has occurred.`);
                SystemData.toggleLoadingProgress(false);
              }
            });
          } else {
            setDialogStates({...dialogStates, showDialog: false, record: null});
          }
        }}

      >
        <Grid container checkChildren={true} spacing={3}>
          <Grid item xs={3} checkChildren={true}>
            <InputLabel>Costing Number</InputLabel>
            <MaskedNumber 
              name="costingNumber" 
              prefix="UCN-" 
              decimalScale={0}
              thousandsGroupStyle=""
              thousandSeparator=""
            />
          </Grid>
          <Grid item xs={12} checkChildren={true}>
            {(record, changeRecord) => (
              <CostingDetails record={record} changeRecord={changeRecord} queryClient={queryClient} />
            )}
          </Grid>
        </Grid>
      </FormDialog>
    )
  }
  return (<></>);
}

export default AttachCostingDialog;
